import { memo, useState } from "react";

import { Handle } from "reactflow";

import style from "@styles/pages/flow/boxes/Box.module.scss";

import { BoxTitles } from "@boxes/BoxTitles";
import { BoxTypes } from "@boxes/BoxTypes";
import { BoxValidations } from "@boxes/BoxValidations";
import { ForEach, If } from "@components/control-statements";

import classnames from "classnames/bind";
const css = classnames.bind(style);

export default memo(({ data, selected, isConnectable }) => {
  const [collapse, setCollapse] = useState(false);

  return (
    <div className={css({ selected: selected })}>
      <div
        className={css({
          inner: true,
          group: true,
          needsSetup: !BoxValidations.validate(BoxTypes.FilterGroup, data),
        })}
      >
        <div className={style.header} onClick={() => setCollapse(!collapse)}>
          <div className={style.icon}>
            <i className="far fa-layer-group" />
          </div>
          <div className="d-flex align-center justify-between flex-1">
            <div className="d-flex flex-column">
              <p className={style.title}>{BoxTitles.FilterGroup}</p>
              <If cond={data?.filters?.length}>
                <span className={style.subtitle}>
                  {data?.filters?.length} filtros aplicados
                </span>
              </If>
            </div>
            <If cond={data?.filters?.length}>
              <div className={css({ chevron: true, rotate: collapse })}>
                <i className="fas fa-chevron-down" />
              </div>
            </If>
          </div>
        </div>
        {collapse && (
          <div className={style.collapse}>
            <ul>
              <ForEach
                items={data.filters || []}
                render={(filter) => {
                  return (
                    <li>
                      <p>{filter.label}</p>
                      <div
                        className={style.setup}
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          e.target.parentNode.dispatchEvent(
                            new CustomEvent("click", {
                              bubbles: true,
                              detail: { setup: true, filterId: filter.id },
                            })
                          );
                        }}
                      >
                        <i className="far fa-gear" />
                      </div>
                    </li>
                  );
                }}
              />
            </ul>
          </div>
        )}
      </div>

      <Handle
        type="target"
        position="left"
        className={style.handleTarget}
        isConnectable={isConnectable}
      />
      <Handle
        type="source"
        position="right"
        className={style.handleSource}
        isConnectable={isConnectable}
      />
    </div>
  );
});
